(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.empiric-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function isInInitialViewport(el) {
    var rect = el.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function observeAll(root) {
    (root || document).querySelectorAll('.empiric-reveal:not(.is-visible)').forEach(function (el) {
      // Reveal immediately if already in (or above) the viewport on scan —
      // avoids any flash-of-invisible-content for above-the-fold content like
      // hero text, and sidesteps IntersectionObserver's inherent first-callback
      // delay (which can be long enough to notice inside the Shopify theme
      // editor's preview iframe).
      if (isInInitialViewport(el)) {
        el.classList.add('is-visible');
        return;
      }
      observer.observe(el);
    });
  }

  function revealAllNow() {
    document.querySelectorAll('.empiric-reveal:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeAll(document);
    // Safety net: guarantees content never stays invisible if the observer is
    // ever delayed or blocked (slow devices, theme-editor preview overhead,
    // an unusual embed context, etc.) — worst case, a reveal-in effect is
    // skipped rather than content disappearing.
    setTimeout(revealAllNow, 600);
  });

  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
